import * as Yup from 'yup';

export const cellsReportValidation = Yup.object().shape({
  fromPairingDate: Yup.date()
    .required('שדה חובה')
    .test('from-before-to', 'תאריך התחלה גדול מתאריך סיום', function (value) {
      const to: Date | undefined = this.parent.toPairingDate;
      if (!value || !to) return true;
      return value <= to;
    }),
  toPairingDate: Yup.date()
    .required('שדה חובה')
    .test('to-after-from', 'תאריך סיום קטן מתאריך התחלה', function (value) {
      const from: Date | undefined = this.parent.fromPairingDate;
      if (!value || !from) return true;
      return value >= from;
    }),
  siteIds: Yup.array(Yup.string()).nullable(),
  compoundIds: Yup.array(Yup.string()).nullable(),
  cellId: Yup.string().nullable(),
  cellNumber: Yup.string().nullable(),
  cellNickName: Yup.string().nullable(),
  closetNumber: Yup.string().nullable(),
  lockCaseId: Yup.string().nullable(),
  cellStatus: Yup.number().nullable(),
});
